/** Moeda do produto e do Stripe da conta HelloPeople: BRL. */
export const BILLING_CURRENCY = "BRL" as const;

/** Assinatura Pro mensal. Fonte: cobrança paid-only. */
export const PRO_MONTHLY_BRL = 5.99;

/** Custo unitário de API (conta de sustentabilidade — não é teto de produto). */
export const API_MINUTE_BRL = 0.05;

/** Minutos que o preço cobriria a 5 centavos/min. Conta unitária — não é teto de produto. */
export const PRO_MONTHLY_API_MINUTES = Math.floor(PRO_MONTHLY_BRL / API_MINUTE_BRL);

export const STRIPE_PRO_MONTHLY_PRICE_ID = "price_1UEx5iA9KW9ysrmVJ9WbB5LI";
export const STRIPE_PRO_PRODUCT_ID = "prod_VFRzFv47ToH9Nx";

export function formatProMonthlyPrice(): string {
  return `R$${PRO_MONTHLY_BRL.toFixed(2).replace(".", ",")}`;
}

/** O que a assinatura Pro libera — copy compartilhada da web (landing + Upgrade). */
export const PRO_FEATURES = [
  "Conversas liberadas, sem cota",
  "Ensaio em voz com a IA",
  "Tradutor em tempo real nas conversas, quando o treino bastou",
  "Catálogo inteiro por nível",
  "Como foi depois de cada conversa",
  "Histórico inteiro",
  "Cancele quando quiser",
] as const;

export type PaidSubscriptionInput = {
  tier?: string | null;
  status?: string | null;
} | null;

export function isPaidSubscription(subscription: PaidSubscriptionInput): boolean {
  const tier = subscription?.tier;
  const status = subscription?.status;
  const paidTier = tier === "pro" || tier === "teams";
  const active = status === "active" || status === "trialing";
  return Boolean(paidTier && active);
}
